<template>
 
  <v-card class="mx-auto" >
    <v-card-text class="group-tit py-1" ><span class="tit-icon"></span>{{value=== 1? batch1: value === 2 ? batch2 : batch3}}</v-card-text>
      <v-row class="pa-0 ma-0"> 
        <v-col cols="3"> 
          <div id="planActual">
            <div :style="computedStyle('plan')">Plan</div>
            <div :style="computedStyle('actual')">Actual</div>
          </div>         
        </v-col>
        <v-col >                     
          <DxChart
            id="chart"
            :data-source="value === 1? blastingData1 : value=== 2 ? blastingData2 : blastingData3"
            title=""
            @pointClick=""
            :size="{ height: 250, width:screenSize==='xs'? 90 : screenSize==='sm'? 160: '100%'}"
          >
            <DxCommonSeriesSettings
              argument-field="div"
              type="bar"
              hover-mode="allArgumentPoints"
              selection-mode="allArgumentPoints"
              :barPadding="0.05"
            >
              <DxLabel :visible="false">
                <DxFormat
                  :precision="0"
                  type="fixedPoint"
                />
              </DxLabel>
            </DxCommonSeriesSettings>
            
            <!-- <DxAdaptiveLayout :width="300" :height="200" /> -->

            <DxValueAxis :inverted="false" />
            <DxSeries
              value-field="plan"
              name="Plan"
            />
            <DxSeries
              value-field="actual"
              name="Actual"
            />
            <DxLegend
              :visible="false"
              vertical-alignment="top"
              horizontal-alignment="center"
            />
            <DxExport :enabled="false"/>
          </DxChart>
        </v-col >  
        <!-- <v-col cols="1" > </v-col>      -->
        <v-col >
          <DxChart
            id="chart"
            :data-source="value === 1? paintingData1 : value=== 2 ? paintingData2 : paintingData3 "
            title=""
            @pointClick=""
            :size="{ height: 250, width: screenSize==='xs'? 90 : screenSize==='sm'? 160: '100%'}"
          >
            <DxCommonSeriesSettings
              argument-field="div"
              type="bar"
              hover-mode="allArgumentPoints"
              selection-mode="allArgumentPoints"
              :barPadding="0.05"
              
            >
              <DxLabel :visible="false">
                <DxFormat
                  :precision="0"
                  type="fixedPoint"
                />
              </DxLabel>
            </DxCommonSeriesSettings>

            <!-- <DxAdaptiveLayout :width="300" :height="200" /> -->
            
            <DxValueAxis :inverted="false" />
            <DxSeries
              value-field="plan"
              name="Plan"
            />
            <DxSeries
              value-field="actual"
              name="Actual"
            />
            <DxLegend
              :visible="false"
              vertical-alignment="top"
              horizontal-alignment="center"
            />
            <DxExport :enabled="false"/>
          </DxChart>
        </v-col>
          <table class="dock-batch">
          <colgroup>
            <col style="width:30%" />
            <col style="width:35%" />
            <col style="width:35%" />
          </colgroup>
          <thead >
            <tr>
              <th colspan="3">{{value=== 1? ship1: value === 2 ? ship2 : ship3}}</th>
            </tr>  
            <tr>
              <th v-for="(item, index) in header" :key="index">{{item.colnm}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="value===1" v-for="(item, index) in data1" :key="index">
              <td class="td-titsub-bg" >{{item.div}}</td>
              <td ><span :style="item.blst > 0 ? 'cursor: pointer' : ''" >{{item.blst}}</span></td>
              <td ><span :style="item.paint > 0 ? 'cursor: pointer' : ''" >{{item.paint}}</span></td>
            </tr>
            <tr v-if="value===2" v-for="(item, index) in data2" :key="index">
              <td class="td-titsub-bg" >{{item.div}}</td>
              <td ><span :style="item.blst > 0 ? 'cursor: pointer' : ''" >{{item.blst}}</span></td>
              <td ><span :style="item.paint > 0 ? 'cursor: pointer' : ''" >{{item.paint}}</span></td>
            </tr>
            <tr v-if="value===3" v-for="(item, index) in data3" :key="index">
              <td class="td-titsub-bg" >{{item.div}}</td>
              <td ><span :style="item.blst > 0 ? 'cursor: pointer' : ''" >{{item.blst}}</span></td>
              <td ><span :style="item.paint > 0 ? 'cursor: pointer' : ''" >{{item.paint}}</span></td>
            </tr>
          </tbody>
        </table>
          <div>
          <!-- Hiển thị giá trị của message nhận được từ component cha -->
          <!-- <p>{{ value }}</p> -->
        </div> 
      </v-row>
  </v-card> 
     
</template>


<script>
import moment from 'moment';
import echart from '@/components/echart/ECharts.vue';
import {
  DxChart,
  DxSeries,
  DxCommonSeriesSettings,
  DxLabel,
  DxFormat,
  DxLegend,
  DxExport,
  DxArgumentAxis,
  DxValueAxis
} from 'devextreme-vue/chart';
import notify from 'devextreme/ui/notify' // message
import EventBus from '@/components/event-bus'
import { dockStatus, 
         dockChart,
         dailyManpower, 
         blastingBlockList, 
         inspectionBlockList,  } from '@/api/view/pp/20/v20a6000.js'


export default {
  name: "v20a6000pcDockBatch",
  props: {
    value: {
      type: Number,
      required: true // Đảm bảo prop này được truyền vào
    }
  },
  components: {
    echart,
    DxChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxLabel,
    DxFormat,
    DxLegend,
    DxExport,
    DxArgumentAxis,
    DxValueAxis
  },
  mounted() {
  },
  data() {
    let data = {
      toDate: moment().format("YYYY-MM-DD"),
      header: [
        { colnm: "Delay<100%<Pre" },
        { colnm: "Blasting(m2)" },
        { colnm: "Painting(Ea)" },
      ],
    };

    // Tạo các biến động cho data1, data2, data3; blastingData, paintingData, batch, ship
    for (let i = 1; i <= 3; i++) {
      data[`data${i}`] = [];
      data[`blastingData${i}`] = [];
      data[`paintingData${i}`] = [];
      data[`batch${i}`] = "";
      data[`ship${i}`] = "";
    }

    return data;
  },
  created() {
    // console.log('getValue: ',this.value);
    // Khởi tạo các mảng data1, data2, data3
    //Dùng vòng lặp for để khởi tạo mảng từ data1 → data3, blastingData1 → blastingData3, paintingData1 → paintingData3
    for (let i = 1; i <= 3; i++) {
      this[`data${i}`] = [];//Dùng this[key] để truy cập động vào các biến
      this[`blastingData${i}`] = [];
      this[`paintingData${i}`] = [];
    }
    this.doSearchDockChart();
    this.doSearchDockStatus();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; // Trả về true nếu màn hình nhỏ hơn mobileBreakpoint (mặc định 1264px)
    },
    screenSize() {
      return this.$vuetify.breakpoint.name; // Trả về tên breakpoint: 'xs', 'sm', 'md', 'lg', 'xl'
    },
   
  },
  watch: {
    isMobile(newValue) {
      // console.log("isMobile_m_dock: ", newValue);
    },

    screenSize(newValue){
      // console.log("screenSize_m_dock: ", newValue);
    }
     
  },
  methods: {
    
    computedStyle(e) {
      return {
        backgroundColor: e==='plan'?'#1db2f5':'#f5564a',
        fontSize: this.screenSize === 'xs' ? '11px' : this.screenSize === 'sm' ? '12px' : '14px',
        fontWeight: 'bold',
        textAlign: 'center'
      };
    },

    async doSearchDockChart() {
      try {
        // this.openLoading('Loading...')

        let params = {
          rank: this.value
        };
        // console.log('rank', this.value);
        await dockChart(params).then(res => {
          // console.log('res', res);
          if (res.list.length > 0) {
            //blastingKey = "blastingData1" nếu this.value === 1, "blastingData2" nếu this.value === 2, v.v.
            //paintingKey = "paintingData1", "paintingData2", v.v.
            const blastingKey = `blastingData${this.value}`;
            const paintingKey = `paintingData${this.value}`;

            if (this[blastingKey] && this[paintingKey]) {//Dùng this[key] để truy xuất biến động
              const { bplan, bactual, pplan, pactual } = res.list[0]; // Destructuring để gọn hơn

              this[blastingKey].push({ div: "Blasting", plan: bplan, actual: bactual }); //this[blastingKey] tương đương với this.blastingData1, this.blastingData2,...
              this[paintingKey].push({ div: "Painting", plan: pplan, actual: pactual }); //this[paintingKey] tương đương với this.paintingData1, this.paintingData2,...
            }
           
          } else {
            const blastingKey = `blastingData${this.value}`; //Tạo key động dựa trên this.value
            const paintingKey = `paintingData${this.value}`; //Tạo key động dựa trên this.value

            if (this[blastingKey] && this[paintingKey]) {//Dùng this[key] để truy cập động vào biến. this[blastingKey] tương đương với this.blastingData1, this.blastingData2,...
              this[blastingKey].splice(0);//Dùng splice(0) để xóa tất cả phần tử trong mảng
              this[paintingKey].splice(0);
            }
            
            //  this.cntDailyMP = 0
          }
          // console.log('######cntDailyMP===>', this.data)
        })
      } finally {
        // this.endLoading()
      }
    },

    async doSearchDockStatus() {
      try {
        // this.openLoading('Loading...')

        let params = {
          rank: this.value
        };
        await dockStatus(params).then(res => {
          // console.log('res', res);
          if (res.list.length > 0) {
            const index = this.value; //Tạo biến index = this.value để dùng cho tất cả thuộc tính. Nếu this.value === 1, thì data1, batch1, ship1 được cập nhật.
            if (index >= 1 && index <= 3) {//Dùng this[key] để truy cập động vào biến. this["data1"] tương đương với this.data1.
              this[`data${index}`] = res.list; 
              this[`batch${index}`] = res.list[0].batch;
              this[`ship${index}`] = res.list[0].ship;
            }
            
          } else {
            const dataKey = `data${this.value}`; //Tạo key động dataKey = "data1", "data2", "data3" dựa trên this.value. Nếu this.value === 1, thì dataKey = "data1".
            if (this[dataKey]) { //Dùng this[dataKey] để truy cập vào biến tương ứng
              this[dataKey].splice(0);
            }            
            //  this.cntDailyMP = 0
          }
          // console.log('######cntDailyMP===>', this.data)
        })
      } finally {
        // this.endLoading()
      }
    },
  }
}
</script>

<style >
/* #chart {
  height: 380px;
} */

/* Dock batch */
table, td, th {
  border: 1px solid;
}

table {
  width: 100%;
  border-collapse: collapse;
}

.dock-batch{
    width: calc(98% - 15px);
    font-size: 9pt; 
    margin: 10px 15px;
    border: 1px solid #d4e5f9;
    border-radius: 4px;
    text-align: center;
    height: calc(30% - 40px);
  
}
.dock-batch th{
    font-size: 9pt;
    color: #444;
    background-color: #e7e8ef;
    border: 1px solid #c9d5e3;
    padding: 2px 0;

}
.dock-batch .td-titsub-bg{
    background-color: #f1f2f6;
}
.dock-batch td{
    border: 1px solid #c9d5e3;
    padding: 5px 0;
}

#planActual {
  width:  100%;
  height: 250px;
  border: 0px solid #1db2f5;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
}

#planActual div {
  margin: 5px 5px;
  width: 100%;
  height: 250px;
}


</style>